import { IonSkeletonText } from '@ionic/react';
import React from 'react';

import { SkeletonProps } from './types';

const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = '16px',
  borderRadius,
  style,
}) => {
  return (
    <IonSkeletonText
      animated
      style={{
        width,
        height,
        borderRadius,
        ...style,
      }}
    />
  );
};

export default Skeleton;
